import { useEffect } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { Card, CardBody, CardSubtitle, CardText } from 'reactstrap'

import * as IpRestrictedSlice from 'slices/ipRestrictedSlice'

import suspendedIcon from 'images/suspended.svg'

import styles from './styles.module.scss'

const IpRestricted = () => {
  const dispatch = useDispatch()
  const { show } = useSelector(IpRestrictedSlice.selectIpRestrictedStatus, shallowEqual)

  useEffect(() => {
    if (show) {
      dispatch(IpRestrictedSlice.close())
    }
  }, [dispatch, show])

  return (
    <div className="d-flex vh-100 align-items-center justify-content-center">
      <Card className={styles.card}>
        <div className={styles.imageContainer}>
          <img className={styles.image} src={suspendedIcon} alt="" />
        </div>
        <CardBody className="text-center">
          <CardSubtitle tag="h4" className="fw-bold">
            ご利用が許可されていません
          </CardSubtitle>
          <CardText className="mt-4">お問い合わせは下記メールアドレスからご連絡ください。</CardText>
          <CardText>
            お問い合わせ
            <br />
            sc_smileboard@sumitomocorp.com
          </CardText>
        </CardBody>
      </Card>
    </div>
  )
}

export default IpRestricted
